import type { CodebaseProductData, productDescription } from '../types/models';
import { resolveRegionValue } from '@/composables/regionHelpers';

type LocalisedContent = Omit<CodebaseProductData['content'], 'description'> & {
  description?: productDescription;
};

export const useStoreContentLocaliseHelper = (
  content: CodebaseProductData['content'],
): LocalisedContent => ({
  ...content,
  description: resolveRegionValue(content.description),
});
